import { render } from "./AddExtras.vue?vue&type=template&id=5c20fb68&scoped=true&lang=pug"
import script from "./AddExtras.vue?vue&type=script&lang=ts"
export * from "./AddExtras.vue?vue&type=script&lang=ts"

import "./AddExtras.vue?vue&type=style&index=0&id=5c20fb68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c20fb68"

export default script